import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewPlaygroundComponent } from './new-playground.component';

const routes: Routes = [
  {
    path: '',
    children: [
        {
            path: '',
            component: NewPlaygroundComponent
        },
        {
            path: ':id',
            component: NewPlaygroundComponent
        }
    ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewPlaygroundRoutingModule { }
